import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
`;

const fadeOut = keyframes`
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
`;

export const Container = styled.div`
    position: absolute;
    bottom: 168px;
    left: 460px;
    right: 460px;
    height: 120px;
    background-color: ${p => p.theme.c.cardBackground};
    border: solid 3px black;
    border-radius: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: ${fadeIn} 800ms;
    z-index: 1;

    &.FadeOut {
        animation: ${fadeOut} 500ms forwards;
    }
`;

export const SolfaName = styled.div`
    font-size: 42px;
    margin: 0 36px;
    color: black;
    transition: opacity 500ms;
    text-shadow: 0 0 3px ${p => p.theme.c.blackShadow3};
`;

export const EqualMark = styled.div`
    font-size: 36px;
    color: black;
    transition: opacity 500ms;
`;